<template>
  <div class="ball-container">
    <div
      v-for="(ball, index) in balls"
      :key="index"
      class="ball"
      :style="{ background: ball.color, width: ballSize + 'px', height: ballSize + 'px', margin: spacing + 'px' }"
    >
      <md-tooltip md-direction="top">
        {{ ball.message }}
      </md-tooltip>
      <span
        class="number"
        :style="{ 'font-size': ballFontSize + 'px' }"
      >{{ ball.number }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorBalls',
  props: {
    balls: {
      type: Array,
      required: true
    },
    ballSize: {
      type: Number,
      required: true
    },
    spacing: {
      type: Number
    },
    ballFontSize: {
      type: Number
    }
  }
}
</script>

<style scoped lang="scss">
.ball-container {
  display: flex;
  flex-wrap: wrap;
}

.ball {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: white;
  font-size: 14px;
  position: relative;

  &:first-child,
  &:nth-child(5n) {
    margin-left: 0 !important;
  }
}

.number {
  font-weight: bold;
  z-index: 1;
}

md-tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px;
  border-radius: 3px;
  white-space: nowrap;
  z-index: 2;
}
</style>
